import React from "react";
import Chip from "@material-ui/core/Chip";
import { i18n } from "../../translate/i18n";
import { getHealthStyle, getHealthLabelKey } from "../../pages/SuperConnectionsDashboard/superConnectionsUtils";

const ConnectionHealthChip = ({ health, size = "small" }) => {
  const { background, color } = getHealthStyle(health);

  return (
    <Chip
      label={i18n.t(getHealthLabelKey(health))}
      size={size}
      style={{ backgroundColor: background, color, fontWeight: 500 }}
    />
  );
};

export default ConnectionHealthChip;
